export const LOCAL_STORAGE_STORED_USER_KEY = 'user';
export const LOCAL_STORAGE_ACCESS_TOKEN_KEY = 'accessToken';
export const LOCAL_STORAGE_REFRESH_TOKEN_KEY = 'refreshToken';
export const LOCAL_STORAGE_TWO_2FA_ACCESS_TOKEN_KEY = '2faAccessToken';